/**
 * Commit messages originated from the frontend (explicit save / sync).
 * Most history messages are authored in `src-tauri/src/commit_messages.rs`.
 *
 * Keep these in sync with the Rust `SAVE` / related constants when editing.
 * Writer-facing titles in the history panel: see `humanizeChangeTitle` in
 * `fileHistory.ts`.
 */

export const COMMIT_SAVE = "Save";
